import { API_URL_WHALESHARK_FGINDEX } from "@constants/Clients/whaleshark/whaleshark.env";
import apiInstance from "@services/Shared/instanceAxios";

const getItems = () =>
  apiInstance({
    url: API_URL_WHALESHARK_FGINDEX,
    params: {
      order: "desc",
      sort: "createdAt",
    },
  });

export default getItems;
